import React, { Component } from "react";
import intl from "react-intl-universal";
import { withRouter } from "next/router";
import { ConfigProvider } from "antd";
import en_US from "antd/lib/locale-provider/en_US";
import zh_CN from "antd/lib/locale-provider/zh_CN";
import ms_MY from "antd/lib/locale-provider/ms_MY";
import moment from "moment";
import "moment/locale/zh-cn";
import "moment/locale/ms-my";
import "moment/locale/en-gb";
import http from "axios";

const LOCALES = [
  {
    name: "English",
    value: "en-US",
  },
  {
    name: "简体中文",
    value: "zh-CN",
  },
  {
    name: "Bahasa Malaysia",
    value: "ms-MY",
  },
];

class LanguageProvider extends Component {
  state = { initDone: false, antd_locale: en_US };

  componentDidMount() {
    this.loadLocales();
  }

  loadLocales() {
    // const { changeLocalization } = this.props;
    let currentLocale = intl.determineLocale({
      urlLocaleKey: "localization",
      cookieLocaleKey: "localization",
    });

    console.log(currentLocale);
    // console.log(window.recaptchaOptions);
    // if (!_.find(LOCALES, { value: currentLocale })) {
    //   //Default Language
    //   moment.locale("en-gb]");
    //   currentLocale = "en-US";
    //   window.recaptchaOptions = {
    //     lang: "en-GB",
    //   };
    // } else {
    //   changeLocalization(currentLocale);
    switch (currentLocale) {
      case "en-US":
        moment.locale("en-gb");
        window.recaptchaOptions = {
          lang: "en-GB",
        };
        this.setState({ antd_locale: en_US });
        break;
      case "zh-CN":
        moment.locale("zh-cn");
        window.recaptchaOptions = {
          lang: "zh-CN",
        };
        this.setState({ antd_locale: zh_CN });
        break;
      case "ms-MY":
        console.log("Runned");
        moment.locale("ms-my");
        window.recaptchaOptions = {
          lang: "ms",
        };
        this.setState({ antd_locale: ms_MY });
        break;
      default:
        //Default language
        moment.locale("en-gb");
        window.recaptchaOptions = {
          lang: "en-GB",
        };
        this.setState({ antd_locale: en_US });
        currentLocale = "en-US";
        break;
    }
    // }
    console.log(currentLocale);
    http
      .get(`/locale/${currentLocale}.json`)
      .then((res) => {
        return intl.init({
          currentLocale,
          locales: {
            [currentLocale]: res.data,
          },
        });
      })
      .then(() => {
        this.setState({ initDone: true });
      });
  }

  render() {
    return (
      <ConfigProvider locale={this.state.antd_locale}>
        {this.state.initDone ? this.props.children : "Loading..."}
      </ConfigProvider>
    );
  }
}

export default withRouter(LanguageProvider);
